export type GapStrength = 'major' | 'moderate' | 'minor'

export function computeGapStrength(
  zScore: number | null | undefined,
): GapStrength {
  if (zScore == null) return 'minor'
  const abs = Math.abs(zScore)
  if (abs >= 2) return 'major'
  if (abs >= 1) return 'moderate'
  return 'minor'
}
